const LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;
const PLACEHOLDER_WORDS: ReadonlySet<string> = new Set([
  "null",
  "none",
  "n a",
  "na",
  "nil",
  "undefined",
  "not applicable",
  "no note",
  "nothing",
]);

const asWords = (value: string): string => value.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();

export const hasMeaningfulText = (value: string | null | undefined): value is string =>
  typeof value === "string" && LETTER_OR_DIGIT.test(value) && !PLACEHOLDER_WORDS.has(asWords(value));

export const meaningfulOrNull = (value: string | null | undefined): string | null =>
  hasMeaningfulText(value) ? value.trim() : null;
